import { useCallback, useMemo } from 'react'

import { EmptyProvider } from '@/components/ui/empty/empty-provider.tsx'
import { EmptyTableContent } from '@/components/ui/empty/empty-table-content.tsx'
import { DataTable } from '@/components/ui/table/controlled-pagination/DataTable'
import type { WelcomeMessage } from '@/modules/creator-settings/types.ts'
import { buildColumns } from '@/modules/creator-settings/welcome-messages/components/tables/columns.tsx'

interface Props {
  messages: WelcomeMessage[]
  handleToggleChange: (id: number, value: boolean) => Promise<unknown>
  deleteMessage: (id: number) => Promise<unknown>
}
export const WelcomeMessagesTable = ({
  messages,
  handleToggleChange,
  deleteMessage,
}: Props) => {
  const renderEmpty = useCallback(
    () => (
      <EmptyTableContent>
        It looks like you don&#39;t have any messages created yet, click on the{' '}
        <span className="text-pointer text-primary-500">Add Message</span>{' '}
        button to do so.
      </EmptyTableContent>
    ),
    [],
  )

  const columns = useMemo(
    () =>
      buildColumns({
        toggleMessage: handleToggleChange,
        deleteMessage,
      }),
    [deleteMessage, handleToggleChange],
  )

  return (
    <EmptyProvider render={renderEmpty}>
      <DataTable
        tbodyMinHeight={false}
        hasActionColumn
        columns={columns}
        data={messages}
      />
    </EmptyProvider>
  )
}
